import classnames from 'classnames';
import React, { ChangeEvent } from 'react';

import { ErrorLabel, Label } from '@eika/label';

import TranslationsConfigType from '../../../../translations/translationType';
import AccountNumberInput from './AccountNumberInput';

import './AccountNumberField.scss';

interface Props {
    accountNumber: string;
    handleAccountNumberChange: (event: ChangeEvent<HTMLInputElement>) => void;
    translated: TranslationsConfigType;
    validationMessage?: string;
    attentionMessage?: string;
    onFocus?: () => void;
    onBlur?: () => void;
}

const AccountNumberField: React.FC<Props> = ({
    accountNumber,
    handleAccountNumberChange,
    translated,
    validationMessage,
    attentionMessage,
    onFocus,
    onBlur,
}) => (
    <>
        <label htmlFor="account-number-input" className="account-number-field__label">
            {translated.accountNumber}
        </label>
        <AccountNumberInput
            className={classnames('account-number-field__input', { 'account-number-field__error': validationMessage })}
            placeholder={translated.accountNumber}
            value={accountNumber}
            onChange={handleAccountNumberChange}
            onFocus={onFocus}
            onBlur={onBlur}
            id="account-number-input"
        />
        {validationMessage && <ErrorLabel text={validationMessage} />}
        {attentionMessage && !validationMessage && <Label text={attentionMessage} />}
    </>
);

export default AccountNumberField;
